// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__dSZh6","info":"PatientInfo_info__9-I8z"};